export { default as ThreeDStockProductsCompactListItemInfoBrand } from './ThreeDStockProductsCompactListItemInfoBrand';
